import React from 'react';

import MemberResultContent from '../MemberResultContent';
import PreBetRoundPreview from '../PreBetRoundPreview';

function ConfirmedRoomContent({ responsiveMode, resultContent, viewProps }) {
  const hasResultContent = Boolean(resultContent?.dialogDatas?.result);

  return (
    <>
      {hasResultContent ? (
        <MemberResultContent
          responsiveMode={responsiveMode}
          user={resultContent.user}
          dialogDatas={resultContent.dialogDatas}
          resultFetchState={resultContent.resultFetchState}
        />
      ) : (
        <PreBetRoundPreview viewProps={viewProps} />
      )}
    </>
  );
}

export default ConfirmedRoomContent;
